module.exports = __webpack_public_path__ + "img/asphalted.bb5ee15b.png";